import React, { useState, useEffect, useCallback, useContext } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { Search } from "./search-filters";
import { UPDATE_FILTERS_DATA } from "../state";
import { TableContext } from "../table";

export const AnnouncementsSearchOnlyToolbar: React.FC = () => {
  const { dispatch } = useContext(TableContext);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={2} justify="flex-end">
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Title"}
          ></Search>
        </Grid>
      </Grid>
    </Box>
  );
};
